/* eslint-disable react/forbid-prop-types */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useCookies } from '@brochure/globals';

import PlpContext from '../Plp/context';
import Layout from '../../components/Layout';
import SEO from '../../components/Seo';
import Hero from '../../components/Hero/SbaApply';
import Reqs from '../../components/Reqs';
import RequiredDocs from '../../components/RequiredDocs';
import Points from '../../components/Points';
import Holder from '../../components/Holder';
import '../../styles/_entrypoint.css';
import './styles.scss';

const SbaApply = ({ pageContext: { sbaPosts, link, title }, location }) => {
  const docsRef = useRef(null);

  useCookies();

  return (
    <PlpContext.Provider
      value={{ plp: sbaPosts, hideAppLinks: true, template: 'SbaPost' }}
    >
      <SEO
        plp={{
          link,
          title,
        }}
        template="SbaApply"
      />
      <Helmet>
        <body className="plp-layout" />
      </Helmet>
      <Layout>
        <main id="main" className="landing-main">
          {sbaPosts.coBrandedLogo && (
            <div className="sub-nav-logo">
              <img
                src={sbaPosts.coBrandedLogo.sourceUrl}
                alt={`${title} logo`}
              />
            </div>
          )}
          <Hero post={sbaPosts} location={location} ref={docsRef} />
          <Reqs />
          <RequiredDocs ref={docsRef} />
          <Points location={location} />
          <Holder />
        </main>
      </Layout>
    </PlpContext.Provider>
  );
};

SbaApply.propTypes = {
  pageContext: PropTypes.shape({
    sbaPosts: PropTypes.object,
    link: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  location: PropTypes.object.isRequired,
};

export default SbaApply;
